import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  Bootstrap,
} from '../components';

import {
  Header,
  Footer
} from '../containers';

/**
 *
 */
const NoMatch = ({location}) => (
  <div>
    <Header />
    <Bootstrap.Container>
      <h3>Error</h3>
      <p>403 not found.<code>{location.pathname}</code>未找到，请通知系统管理员.</p>
    </Bootstrap.Container>
    <Footer />
  </div>
);

export default withRouter(NoMatch);



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/NoMatch.js